import { gql } from '@apollo/client';

const APP_ACCESS_DETAILS_FRAGMENT = gql`
  fragment BaseAppAccessDetails on AppAccessDetails {
    url
    bannerUrl
    iosUrl
  }
`;

export default APP_ACCESS_DETAILS_FRAGMENT;
